import Vue from 'vue'

import './components'

import './plugins'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync'

import firebase from 'firebase'
import { firestorePlugin } from 'vuefire'

import vuemoment from 'vue-moment'

import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'

import './registerServiceWorker'

if ('scrollRestoration' in history) { history.scrollRestoration = 'manual' }

sync(store, router)

Vue.config.productionTip = false
Vue.use(firestorePlugin)
Vue.use(vuemoment)

var firebaseConfig = {
  apiKey: 'AIzaSyDCpt6duqoYVAIfdt4R6ICA6d_aSq7rLpo',
  authDomain: 'acappolli-backend.firebaseapp.com',
  databaseURL: 'https://acappolli-backend.firebaseio.com',
  projectId: 'acappolli-backend',
  storageBucket: 'acappolli-backend.appspot.com',
  messagingSenderId: '659334424069',
  appId: '1:659334424069:web:5f5608fe9346bab520de6c'
}
// Initialize Firebase
export const db = firebase.initializeApp(firebaseConfig).firestore()

const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint }

export const firebaseStorage = firebase.storage

export const storageRef = firebase.storage().ref()

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
